import React from "react";
import { connect } from "react-redux";

import TextChart from "../../../Charts/TextChart";

const TextoCreditoMaximo = (props) => {
  const { clientSelected, cliente } = props;

  return (
    <TextChart
      title={`Crédito máximo`}
      bigAmount={clientSelected ? cliente.cuentaCorriente.creditoMaximo : 0}
      currencySimbol={clientSelected ? cliente.cuentaCorriente.moneda : null}
      noClient={!clientSelected}
      bigCurrency
      loading={false}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    clientSelected: state.clientes.clienteById.clientSelected,
    cliente: state.clientes.clienteById.cliente,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(TextoCreditoMaximo);
